export default __webpack_public_path__ + "static/dz-3874bce10d18000766d0d3bf743df753.svg";